export function getBackendBaseUrl() {
    const url = window.location.href.toLowerCase();
    console.debug('window.location.href url: ' + url);
    if (
        url.indexOf('nvhuswebclienttest.azurewebsites.net') > 0 ||
        url.indexOf('test.naturfagsmaraton.dk') > 0 ||
        url.indexOf('test.sciencedysten.dk') > 0) {
        return 'https://nvhuswebapitest.azurewebsites.net';
    } else if (
        url.indexOf('nvhuswebclientdemo.azurewebsites.net') > 0 ||
        url.indexOf('demo.naturfagsmaraton.dk') > 0 ||
        url.indexOf('demo.sciencedysten.dk') > 0) {
        return 'https://nvhuswebapidemo.azurewebsites.net';
    } else if (
        url.indexOf('nvhuswebclientdrift.azurewebsites.net') > 0 ||
        url.indexOf('naturfagsmaraton.dk') > 0 ||
        url.indexOf('sciencedysten.dk') > 0) {
        return 'https://nvhuswebapidrift.azurewebsites.net';
    } else {
        return 'http://localhost:9558';
    }
}    


// WEBPACK FOOTER //
// ./~/tslint-loader!./src/infrastructure/BackendUrlResolver.ts